import package_json from '../package.json';

export const APP_VERSION = `v. ${package_json.version}`;